// Extracted from mist .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const MIST_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.28630000, 0.32159999, 0.27450001],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.40390000, 0.40390000, 0.40779999],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const MIST_MESH_0: RuneMesh = {
  name: "Mist_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64279997, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.67049998, 0.43309996, -0.20980003,
    0.33080000, 0.43309996, -0.35590002,
    0.01490000, 0.43309996, -0.40000004,
    -0.26019999, 0.43309996, -0.39660004,
    -0.58969998, 0.43309996, -0.25390002,
    -0.23310000, 0.43309999, -0.10450003,
    0.01490000, 0.43309999, -0.01960003,
    0.36140001, 0.43309999, -0.06710003,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.61280000, 0.43310001, 0.26239997,
    0.28330001, 0.43309999, 0.10609997,
    -0.02920000, 0.43309999, 0.06539997,
    -0.34850001, 0.43309999, 0.06879997,
    -0.62370002, 0.43310001, 0.20799997,
    -0.34520000, 0.43310001, 0.36089998,
    -0.02250000, 0.43310001, 0.39819998,
    0.31380001, 0.43310001, 0.38809997,
    0.64279997, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79019994,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91289997, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30410001, 0.24339992, -0.93610001,
    0.30410001, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30410001, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30410001, 0.18959993, -0.93610001,
    0.30410001, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91289997, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64279997, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64279997, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79020000,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 47, 48, 1, 47, 1, 0,
    1, 49, 50, 1, 50, 2, 3, 2, 51, 3, 51, 4,
    4, 51, 52, 4, 52, 5, 5, 52, 53, 5, 53, 6,
    6, 53, 54, 6, 54, 7, 7, 54, 55, 7, 55, 8,
    8, 55, 56, 8, 56, 9, 9, 56, 57, 9, 57, 10,
    10, 57, 58, 10, 58, 11, 11, 58, 59, 11, 59, 12,
    12, 59, 60, 12, 60, 13, 13, 60, 61, 13, 61, 14,
    14, 61, 62, 14, 62, 15, 15, 62, 63, 15, 63, 16,
    16, 63, 64, 16, 64, 25, 25, 64, 65, 25, 65, 26,
    26, 65, 66, 26, 66, 27, 27, 66, 67, 27, 67, 36,
    36, 67, 68, 36, 68, 37, 37, 68, 69, 37, 69, 38,
    38, 69, 70, 38, 70, 39, 39, 70, 71, 39, 71, 40,
    40, 71, 72, 40, 72, 41, 41, 72, 73, 41, 73, 42,
    42, 73, 74, 42, 74, 43, 43, 74, 75, 43, 75, 44,
    44, 75, 76, 44, 76, 45, 45, 76, 77, 45, 77, 46,
    46, 77, 48, 46, 48, 47, 48, 78, 49, 48, 49, 1,
    49, 79, 80, 49, 80, 50, 2, 50, 81, 2, 81, 51,
    51, 81, 82, 51, 82, 52, 52, 82, 83, 52, 83, 53,
    53, 83, 84, 53, 84, 54, 54, 84, 85, 54, 85, 55,
    55, 85, 86, 55, 86, 56, 56, 86, 87, 56, 87, 57,
    57, 87, 88, 57, 88, 58, 58, 88, 89, 58, 89, 59,
    59, 89, 90, 59, 90, 60, 60, 90, 91, 60, 91, 61,
    61, 91, 92, 61, 92, 62, 62, 92, 93, 62, 93, 63,
    63, 93, 94, 63, 94, 64, 64, 94, 95, 64, 95, 65,
    65, 95, 96, 65, 96, 66, 66, 96, 97, 66, 97, 67,
    67, 97, 98, 67, 98, 68, 68, 98, 99, 68, 99, 69,
    69, 99, 100, 69, 100, 70, 70, 100, 101, 70, 101, 71,
    71, 101, 102, 71, 102, 72, 72, 102, 103, 72, 103, 73,
    73, 103, 104, 73, 104, 74, 74, 104, 105, 74, 105, 75,
    75, 105, 106, 75, 106, 76, 76, 106, 107, 76, 107, 77,
    77, 107, 78, 77, 78, 48, 78, 108, 79, 78, 79, 49,
    79, 109, 110, 79, 110, 80, 50, 80, 111, 50, 111, 81,
    81, 111, 112, 81, 112, 82, 82, 112, 113, 82, 113, 83,
    83, 113, 114, 83, 114, 84, 84, 114, 115, 84, 115, 85,
    85, 115, 116, 85, 116, 86, 86, 116, 117, 86, 117, 87,
    87, 117, 118, 87, 118, 88, 88, 118, 119, 88, 119, 89,
    89, 119, 120, 89, 120, 90, 90, 120, 121, 90, 121, 91,
    91, 121, 122, 91, 122, 92, 92, 122, 123, 92, 123, 93,
    93, 123, 124, 93, 124, 94, 94, 124, 125, 94, 125, 95,
    95, 125, 126, 95, 126, 96, 96, 126, 127, 96, 127, 97,
    97, 127, 128, 97, 128, 98, 98, 128, 129, 98, 129, 99,
    99, 129, 130, 99, 130, 100, 100, 130, 131, 100, 131, 101,
    101, 131, 132, 101, 132, 102, 102, 132, 133, 102, 133, 103,
    103, 133, 134, 103, 134, 104, 104, 134, 135, 104, 135, 105,
    105, 135, 136, 105, 136, 106, 106, 136, 137, 106, 137, 107,
    107, 137, 108, 107, 108, 78, 108, 138, 109, 108, 109, 79,
    109, 139, 140, 109, 140, 110, 80, 110, 141, 80, 141, 111,
    111, 141, 142, 111, 142, 112, 112, 142, 143, 112, 143, 113,
    113, 143, 144, 113, 144, 114, 114, 144, 145, 114, 145, 115,
    115, 145, 146, 115, 146, 116, 116, 146, 147, 116, 147, 117,
    117, 147, 148, 117, 148, 118, 118, 148, 149, 118, 149, 119,
    119, 149, 150, 119, 150, 120, 120, 150, 151, 120, 151, 121,
    121, 151, 152, 121, 152, 122, 122, 152, 153, 122, 153, 123,
    123, 153, 154, 123, 154, 124, 124, 154, 155, 124, 155, 125,
    125, 155, 156, 125, 156, 126, 126, 156, 157, 126, 157, 127,
    127, 157, 158, 127, 158, 128, 128, 158, 159, 128, 159, 129,
    129, 159, 160, 129, 160, 130, 130, 160, 161, 130, 161, 131,
    131, 161, 162, 131, 162, 132, 132, 162, 163, 132, 163, 133,
    133, 163, 164, 133, 164, 134, 134, 164, 165, 134, 165, 135,
    135, 165, 166, 135, 166, 136, 136, 166, 167, 136, 167, 137,
    137, 167, 138, 137, 138, 108, 138, 168, 139, 138, 139, 109,
    139, 169, 170, 139, 170, 140, 110, 140, 171, 110, 171, 141,
    141, 171, 172, 141, 172, 142, 142, 172, 173, 142, 173, 143,
    143, 173, 174, 143, 174, 144, 144, 174, 175, 144, 175, 145,
    145, 175, 176, 145, 176, 146, 146, 176, 177, 146, 177, 147,
    147, 177, 178, 147, 178, 148, 148, 178, 179, 148, 179, 149,
    149, 179, 180, 149, 180, 150, 150, 180, 181, 150, 181, 151,
    151, 181, 182, 151, 182, 152, 152, 182, 183, 152, 183, 153,
    153, 183, 184, 153, 184, 154, 154, 184, 185, 154, 185, 155,
    155, 185, 186, 155, 186, 156, 156, 186, 187, 156, 187, 157,
    157, 187, 188, 157, 188, 158, 158, 188, 189, 158, 189, 159,
    159, 189, 190, 159, 190, 160, 160, 190, 191, 160, 191, 161,
    161, 191, 192, 161, 192, 162, 162, 192, 193, 162, 193, 163,
    163, 193, 194, 163, 194, 164, 164, 194, 195, 164, 195, 165,
    165, 195, 196, 165, 196, 166, 166, 196, 197, 166, 197, 167,
    167, 197, 168, 167, 168, 138, 168, 198, 169, 168, 169, 139,
    169, 201, 203, 169, 203, 170, 140, 170, 204, 140, 204, 171,
    171, 204, 205, 171, 205, 172, 172, 205, 206, 172, 206, 173,
    173, 206, 207, 173, 207, 174, 174, 207, 208, 174, 208, 175,
    175, 208, 209, 175, 209, 176, 176, 209, 210, 176, 210, 177,
    177, 210, 211, 177, 211, 178, 178, 211, 212, 178, 212, 179,
    179, 212, 213, 179, 213, 180, 180, 213, 214, 180, 214, 181,
    181, 214, 215, 181, 215, 182, 182, 215, 216, 182, 216, 183,
    183, 216, 217, 183, 217, 184, 184, 217, 218, 184, 218, 185,
    185, 218, 219, 185, 219, 186, 186, 219, 220, 186, 220, 187,
    187, 220, 221, 187, 221, 188, 188, 221, 222, 188, 222, 189,
    189, 222, 223, 189, 223, 190, 190, 223, 224, 190, 224, 191,
    191, 224, 225, 191, 225, 192, 192, 225, 226, 192, 226, 193,
    193, 226, 227, 193, 227, 194, 194, 227, 228, 194, 228, 195,
    195, 228, 229, 195, 229, 196, 196, 229, 230, 196, 230, 197,
    197, 230, 198, 197, 198, 168, 198, 232, 201, 198, 201, 169,
    199, 233, 235, 199, 235, 202, 170, 203, 237, 170, 237, 204,
    204, 237, 239, 204, 239, 205, 205, 239, 241, 205, 241, 206,
    206, 241, 243, 206, 243, 207, 207, 243, 245, 207, 245, 208,
    208, 245, 247, 208, 247, 209, 209, 247, 249, 209, 249, 210,
    210, 249, 251, 210, 251, 211, 211, 251, 252, 211, 252, 212,
    212, 252, 254, 212, 254, 213, 213, 254, 256, 213, 256, 214,
    214, 256, 258, 214, 258, 215, 215, 258, 260, 215, 260, 216,
    216, 260, 262, 216, 262, 217, 217, 262, 264, 217, 264, 218,
    218, 264, 266, 218, 266, 219, 219, 266, 268, 219, 268, 220,
    220, 268, 270, 220, 270, 221, 221, 270, 272, 221, 272, 222,
    222, 272, 274, 222, 274, 223, 223, 274, 276, 223, 276, 224,
    224, 276, 278, 224, 278, 225, 225, 278, 280, 225, 280, 226,
    226, 280, 282, 226, 282, 227, 227, 282, 284, 227, 284, 228,
    228, 284, 287, 228, 287, 229, 229, 287, 289, 229, 289, 230,
    230, 289, 232, 230, 232, 198, 231, 290, 234, 231, 234, 200,
    233, 291, 294, 233, 294, 235, 202, 235, 296, 202, 296, 236,
    236, 296, 297, 236, 297, 238, 238, 297, 298, 238, 298, 240,
    240, 298, 299, 240, 299, 242, 242, 299, 300, 242, 300, 244,
    244, 300, 301, 244, 301, 246, 246, 301, 302, 246, 302, 248,
    248, 302, 303, 248, 303, 250, 250, 303, 304, 250, 304, 253,
    253, 304, 305, 253, 305, 255, 255, 305, 306, 255, 306, 257,
    257, 306, 307, 257, 307, 259, 259, 307, 308, 259, 308, 261,
    261, 308, 309, 261, 309, 263, 263, 309, 310, 263, 310, 265,
    265, 310, 311, 265, 311, 267, 267, 311, 312, 267, 312, 269,
    269, 312, 313, 269, 313, 271, 271, 313, 314, 271, 314, 273,
    273, 314, 315, 273, 315, 275, 275, 315, 316, 275, 316, 277,
    277, 316, 317, 277, 317, 279, 279, 317, 318, 279, 318, 281,
    281, 318, 319, 281, 319, 283, 283, 319, 320, 283, 320, 285,
    285, 320, 321, 285, 321, 286, 286, 321, 322, 286, 322, 288,
    288, 322, 290, 288, 290, 231, 290, 323, 293, 290, 293, 234,
    292, 325, 326, 292, 326, 295, 235, 294, 327, 235, 327, 296,
    296, 327, 329, 296, 329, 297, 297, 329, 331, 297, 331, 298,
    298, 331, 333, 298, 333, 299, 299, 333, 335, 299, 335, 300,
    300, 335, 337, 300, 337, 301, 301, 337, 339, 301, 339, 302,
    302, 339, 341, 302, 341, 303, 303, 341, 344, 303, 344, 304,
    304, 344, 346, 304, 346, 305, 305, 346, 348, 305, 348, 306,
    306, 348, 350, 306, 350, 307, 307, 350, 352, 307, 352, 308,
    308, 352, 354, 308, 354, 309, 309, 354, 356, 309, 356, 310,
    310, 356, 358, 310, 358, 311, 311, 358, 360, 311, 360, 312,
    312, 360, 362, 312, 362, 313, 313, 362, 364, 313, 364, 314,
    314, 364, 366, 314, 366, 315, 315, 366, 368, 315, 368, 316,
    316, 368, 370, 316, 370, 317, 317, 370, 372, 317, 372, 318,
    318, 372, 374, 318, 374, 319, 319, 374, 376, 319, 376, 320,
    320, 376, 377, 320, 377, 321, 321, 377, 379, 321, 379, 322,
    322, 379, 323, 322, 323, 290, 324, 381, 325, 324, 325, 292,
    325, 382, 383, 325, 383, 326, 295, 326, 384, 295, 384, 328,
    328, 384, 385, 328, 385, 330, 330, 385, 386, 330, 386, 332,
    332, 386, 387, 332, 387, 334, 334, 387, 388, 334, 388, 336,
    336, 388, 389, 336, 389, 338, 338, 389, 390, 338, 390, 340,
    340, 390, 391, 340, 391, 342, 342, 391, 392, 342, 392, 343,
    343, 392, 393, 343, 393, 345, 345, 393, 394, 345, 394, 347,
    347, 394, 395, 347, 395, 349, 349, 395, 396, 349, 396, 351,
    351, 396, 397, 351, 397, 353, 353, 397, 398, 353, 398, 355,
    355, 398, 399, 355, 399, 357, 357, 399, 400, 357, 400, 359,
    359, 400, 401, 359, 401, 361, 361, 401, 402, 361, 402, 363,
    363, 402, 403, 363, 403, 365, 365, 403, 404, 365, 404, 367,
    367, 404, 405, 367, 405, 369, 369, 405, 406, 369, 406, 371,
    371, 406, 407, 371, 407, 373, 373, 407, 408, 373, 408, 375,
    375, 408, 409, 375, 409, 378, 378, 409, 410, 378, 410, 380,
    380, 410, 381, 380, 381, 324, 381, 411, 382, 381, 382, 325,
    382, 412, 413, 382, 413, 383, 326, 383, 414, 326, 414, 384,
    384, 414, 415, 384, 415, 385, 385, 415, 416, 385, 416, 386,
    386, 416, 417, 386, 417, 387, 387, 417, 418, 387, 418, 388,
    388, 418, 419, 388, 419, 389, 389, 419, 420, 389, 420, 390,
    390, 420, 421, 390, 421, 391, 391, 421, 422, 391, 422, 392,
    392, 422, 423, 392, 423, 393, 393, 423, 424, 393, 424, 394,
    394, 424, 425, 394, 425, 395, 395, 425, 426, 395, 426, 396,
    396, 426, 427, 396, 427, 397, 397, 427, 428, 397, 428, 398,
    398, 428, 429, 398, 429, 399, 399, 429, 430, 399, 430, 400,
    400, 430, 431, 400, 431, 401, 401, 431, 432, 401, 432, 402,
    402, 432, 433, 402, 433, 403, 403, 433, 434, 403, 434, 404,
    404, 434, 435, 404, 435, 405, 405, 435, 436, 405, 436, 406,
    406, 436, 437, 406, 437, 407, 407, 437, 438, 407, 438, 408,
    408, 438, 439, 408, 439, 409, 409, 439, 440, 409, 440, 410,
    410, 440, 411, 410, 411, 381, 411, 441, 412, 411, 412, 382,
    412, 442, 443, 412, 443, 413, 383, 413, 444, 383, 444, 414,
    414, 444, 445, 414, 445, 415, 415, 445, 446, 415, 446, 416,
    416, 446, 447, 416, 447, 417, 417, 447, 448, 417, 448, 418,
    418, 448, 449, 418, 449, 419, 419, 449, 450, 419, 450, 420,
    420, 450, 451, 420, 451, 421, 421, 451, 452, 421, 452, 422,
    422, 452, 453, 422, 453, 423, 423, 453, 454, 423, 454, 424,
    424, 454, 455, 424, 455, 425, 425, 455, 456, 425, 456, 426,
    426, 456, 457, 426, 457, 427, 427, 457, 458, 427, 458, 428,
    428, 458, 459, 428, 459, 429, 429, 459, 460, 429, 460, 430,
    430, 460, 461, 430, 461, 431, 431, 461, 462, 431, 462, 432,
    432, 462, 463, 432, 463, 433, 433, 463, 464, 433, 464, 434,
    434, 464, 465, 434, 465, 435, 435, 465, 466, 435, 466, 436,
    436, 466, 467, 436, 467, 437, 437, 467, 468, 437, 468, 438,
    438, 468, 469, 438, 469, 439, 439, 469, 470, 439, 470, 440,
    440, 470, 441, 440, 441, 411, 441, 471, 442, 441, 442, 412,
    442, 472, 473, 442, 473, 443, 413, 443, 474, 413, 474, 444,
    444, 474, 475, 444, 475, 445, 445, 475, 476, 445, 476, 446,
    446, 476, 477, 446, 477, 447, 447, 477, 478, 447, 478, 448,
    448, 478, 479, 448, 479, 449, 449, 479, 480, 449, 480, 450,
    450, 480, 481, 450, 481, 451, 451, 481, 482, 451, 482, 452,
    452, 482, 483, 452, 483, 453, 453, 483, 484, 453, 484, 454,
    454, 484, 485, 454, 485, 455, 455, 485, 486, 455, 486, 456,
    456, 486, 487, 456, 487, 457, 457, 487, 488, 457, 488, 458,
    458, 488, 489, 458, 489, 459, 459, 489, 490, 459, 490, 460,
    460, 490, 491, 460, 491, 461, 461, 491, 492, 461, 492, 462,
    462, 492, 493, 462, 493, 463, 463, 493, 494, 463, 494, 464,
    464, 494, 495, 464, 495, 465, 465, 495, 496, 465, 496, 466,
    466, 496, 497, 466, 497, 467, 467, 497, 498, 467, 498, 468,
    468, 498, 499, 468, 499, 469, 469, 499, 500, 469, 500, 470,
    470, 500, 471, 470, 471, 441, 471, 501, 472, 471, 472, 442,
    472, 502, 503, 472, 503, 473, 443, 473, 504, 443, 504, 474,
    474, 504, 505, 474, 505, 475, 475, 505, 506, 475, 506, 476,
    476, 506, 507, 476, 507, 477, 477, 507, 508, 477, 508, 478,
    478, 508, 509, 478, 509, 479, 479, 509, 510, 479, 510, 480,
    480, 510, 511, 480, 511, 481, 481, 511, 512, 481, 512, 482,
    482, 512, 513, 482, 513, 483, 483, 513, 514, 483, 514, 484,
    484, 514, 515, 484, 515, 485, 485, 515, 516, 485, 516, 486,
    486, 516, 517, 486, 517, 487, 487, 517, 518, 487, 518, 488,
    488, 518, 519, 488, 519, 489, 489, 519, 520, 489, 520, 490,
    490, 520, 521, 490, 521, 491, 491, 521, 522, 491, 522, 492,
    492, 522, 523, 492, 523, 493, 493, 523, 524, 493, 524, 494,
    494, 524, 525, 494, 525, 495, 495, 525, 526, 495, 526, 496,
    496, 526, 527, 496, 527, 497, 497, 527, 528, 497, 528, 498,
    498, 528, 529, 498, 529, 499, 499, 529, 530, 499, 530, 500,
    500, 530, 501, 500, 501, 471, 501, 531, 502, 501, 502, 472,
    502, 532, 533, 502, 533, 503, 473, 503, 534, 473, 534, 504,
    504, 534, 535, 504, 535, 505, 505, 535, 536, 505, 536, 506,
    506, 536, 537, 506, 537, 507, 507, 537, 538, 507, 538, 508,
    508, 538, 539, 508, 539, 509, 509, 539, 540, 509, 540, 510,
    510, 540, 541, 510, 541, 511, 511, 541, 542, 511, 542, 512,
    512, 542, 543, 512, 543, 513, 513, 543, 544, 513, 544, 514,
    514, 544, 545, 514, 545, 515, 515, 545, 546, 515, 546, 516,
    516, 546, 547, 516, 547, 517, 517, 547, 548, 517, 548, 518,
    518, 548, 549, 518, 549, 519, 519, 549, 550, 519, 550, 520,
    520, 550, 551, 520, 551, 521, 521, 551, 552, 521, 552, 522,
    522, 552, 553, 522, 553, 523, 523, 553, 554, 523, 554, 524,
    524, 554, 555, 524, 555, 525, 525, 555, 556, 525, 556, 526,
    526, 556, 557, 526, 557, 527, 527, 557, 558, 527, 558, 528,
    528, 558, 559, 528, 559, 529, 529, 559, 560, 529, 560, 530,
    530, 560, 531, 530, 531, 501, 531, 561, 532, 531, 532, 502,
    532, 562, 533, 503, 533, 563, 503, 563, 534, 534, 563, 564,
    534, 564, 535, 535, 564, 565, 535, 565, 536, 536, 565, 566,
    536, 566, 537, 537, 566, 567, 537, 567, 538, 538, 567, 568,
    538, 568, 539, 539, 568, 569, 539, 569, 540, 540, 569, 570,
    540, 570, 541, 541, 570, 571, 541, 571, 542, 542, 571, 572,
    542, 572, 543, 543, 572, 573, 543, 573, 544, 544, 573, 574,
    544, 574, 545, 545, 574, 575, 545, 575, 546, 546, 575, 576,
    546, 576, 547, 547, 576, 577, 547, 577, 548, 548, 577, 578,
    548, 578, 549, 549, 578, 579, 549, 579, 550, 550, 579, 580,
    550, 580, 551, 551, 580, 581, 551, 581, 552, 552, 581, 582,
    552, 582, 553, 553, 582, 583, 553, 583, 554, 554, 583, 584,
    554, 584, 555, 555, 584, 585, 555, 585, 556, 556, 585, 586,
    556, 586, 557, 557, 586, 587, 557, 587, 558, 558, 587, 588,
    558, 588, 559, 559, 588, 589, 559, 589, 560, 560, 589, 561,
    560, 561, 531, 561, 562, 532, 533, 562, 563, 563, 562, 564,
    564, 562, 565, 565, 562, 566, 566, 562, 567, 567, 562, 568,
    568, 562, 569, 569, 562, 570, 570, 562, 571, 571, 562, 572,
    572, 562, 573, 573, 562, 574, 574, 562, 575, 575, 562, 576,
    576, 562, 577, 577, 562, 578, 578, 562, 579, 579, 562, 580,
    580, 562, 581, 581, 562, 582, 582, 562, 583, 583, 562, 584,
    584, 562, 585, 585, 562, 586, 586, 562, 587, 587, 562, 588,
    588, 562, 589, 589, 562, 561, 10, 11, 12, 12, 13, 14,
    14, 15, 16, 16, 17, 18, 18, 19, 8, 8, 9, 10,
    10, 12, 14, 14, 16, 18, 18, 8, 10, 14, 18, 10,
    30, 31, 0, 0, 3, 4, 4, 5, 6, 6, 7, 8,
    8, 19, 20, 8, 20, 21, 4, 6, 8, 30, 0, 4,
    4, 8, 21, 30, 4, 21, 30, 21, 22, 30, 22, 23,
    29, 30, 23, 24, 17, 16, 29, 23, 24, 26, 27, 28,
    28, 29, 24, 24, 16, 25, 25, 26, 28, 24, 25, 28,
    39, 40, 41, 41, 42, 43, 43, 44, 45, 45, 46, 47,
    47, 0, 31, 47, 31, 32, 43, 45, 47, 39, 41, 43,
    37, 38, 39, 27, 36, 37, 35, 28, 27, 35, 27, 37,
    37, 39, 43, 43, 47, 32, 43, 32, 33, 35, 37, 43,
    43, 33, 34, 43, 34, 35,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.07239688, 0.99725701, -0.01539934,
    -0.02599901, 0.99966189, 0.00039998,
    -0.29589105, -0.21689345, 0.93027185,
    -0.05349992, -0.29239956, 0.95479854,
    0.27838794, -0.21689060, 0.93565946,
    0.99734344, -0.07280317, 0.00240010,
    0.34639893, -0.26459922, -0.89999724,
    0.08089871, -0.28339549, -0.95558484,
    -0.33850664, -0.22110435, -0.91461802,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05590144, 0.99812574, 0.02490064,
    -0.03650119, -0.99933263, -0.00140005,
    -0.31541152, -0.22360816, 0.92223368,
    -0.05380120, -0.29840667, 0.95292124,
    0.33598768, -0.17969343, 0.92456614,
    0.99648941, -0.07989914, 0.02499973,
    0.38478087, -0.17609126, -0.90605494,
    0.03689968, -0.34739701, -0.93699185,
    -0.28370657, -0.23280541, -0.93022160,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43951681, 0.89823436, 0.00000000,
    -0.42999631, 0.89819227, -0.09139921,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15369423, 0.97326347, -0.17069359,
    0.18590659, 0.97323452, -0.13510480,
    0.20960329, 0.97331528, -0.09340147,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20950964, 0.97334476, 0.09330429,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399934, 0.97327301, 0.22839368,
    -0.02399988, 0.97329524, 0.22829889,
    -0.07099969, 0.97329573, 0.21829904,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43007782, 0.89815365, 0.09139528,
    -0.62772702, 0.77843355, 0.00000000,
    -0.61396481, 0.77845540, -0.13059251,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61423280, 0.77824154, 0.13060698,
    -0.78468818, 0.61989069, 0.00000000,
    -0.76752538, 0.61992050, -0.16310540,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76752538, 0.61992050, 0.16310540,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189903, 0.22119788, -0.96989076,
    0.30138787, 0.22089110, -0.92756265,
    0.48760288, 0.22110131, -0.84460502,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439560, 0.05599764, -0.99295812,
    0.10439560, 0.05599764, -0.99295812,
    0.30849597, 0.05579927, -0.94958764,
    0.30849597, 0.05579927, -0.94958764,
    0.49918934, 0.05599880, -0.86468152,
    0.49918934, 0.05599880, -0.86468152,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50001101, 0.00000000, -0.86601905,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439560, -0.05599764, -0.99295812,
    0.10439560, -0.05599764, -0.99295812,
    0.30849597, -0.05579927, -0.94958764,
    0.30849597, -0.05579927, -0.94958764,
    0.49918934, -0.05599880, -0.86468152,
    0.49918934, -0.05599880, -0.86468152,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30139453, -0.22079598, -0.92758314,
    0.48760288, -0.22110131, -0.84460502,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76752538, -0.61992050, -0.16310540,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76752538, -0.61992050, 0.16310540,
    -0.62772702, -0.77843355, 0.00000000,
    -0.61423280, -0.77824154, -0.13060698,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61423280, -0.77824154, 0.13060698,
    -0.43951681, -0.89823436, 0.00000000,
    -0.42999631, -0.89819227, -0.09139921,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.42999631, -0.89819227, 0.09139921,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15369423, -0.97326347, -0.17069359,
    0.18590659, -0.97323452, -0.13510480,
    0.20950964, -0.97334476, -0.09330429,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20950964, -0.97334476, 0.09330429,
    0.18590659, -0.97323452, 0.13510480,
    0.15369423, -0.97326347, 0.17069359,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399934, -0.97327301, 0.22839368,
    -0.02399988, -0.97329524, 0.22829889,
    -0.07099969, -0.97329573, 0.21829904,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04019983, -0.99819579, -0.04459981,
    0.04850013, -0.99820273, -0.03520010,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04850013, -0.99820273, 0.03520010,
    0.04009999, -0.99819980, 0.04459999,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630002, -0.99820245, 0.05960015,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01850016, -0.99820844, 0.05690048,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
  ]),
  materialIndex: 0,
};

const MIST_MESH_1: RuneMesh = {
  name: "Mist_Rune_primitive1",
  positions: new Float32Array([
    0.67049998, 0.43309996, -0.20980003,
    0.33080000, 0.43309996, -0.35590002,
    0.01490000, 0.43309996, -0.40000004,
    -0.26019999, 0.43309996, -0.39660004,
    -0.26019999, 0.43309996, -0.39660004,
    -0.58969998, 0.43309996, -0.25390002,
    -0.58969998, 0.43309996, -0.25390002,
    -0.23310000, 0.43309999, -0.10450003,
    -0.23310000, 0.43309999, -0.10450003,
    0.01490000, 0.43309999, -0.01960003,
    0.36140001, 0.43309999, -0.06710003,
    0.36140001, 0.43309999, -0.06710003,
    0.61280000, 0.43310001, 0.26239997,
    0.28330001, 0.43309999, 0.10609997,
    -0.02920000, 0.43309999, 0.06539997,
    -0.34850001, 0.43309999, 0.06879997,
    -0.62370002, 0.43310001, 0.20799997,
    -0.34520000, 0.43310001, 0.36089998,
    -0.02250000, 0.43310001, 0.39819998,
    0.31380001, 0.43310001, 0.38809997,
    0.47700000, 0.38979998, -0.20660003,
    0.26320001, 0.38979998, -0.28830004,
    0.02300000, 0.38979998, -0.33870003,
    -0.16910000, 0.38979998, -0.33870003,
    -0.16910000, 0.38979998, -0.33870003,
    -0.39010000, 0.38979998, -0.24990003,
    -0.39010000, 0.38979998, -0.24990003,
    -0.19200000, 0.38980001, -0.16500004,
    0.01340000, 0.38980001, -0.07690003,
    0.24879999, 0.38980001, -0.11300003,
    0.43140000, 0.38980004, 0.24969997,
    0.21520001, 0.38980001, 0.16809997,
    -0.02740000, 0.38980001, 0.12479997,
    -0.21240000, 0.38980001, 0.12479997,
    -0.44049999, 0.38980004, 0.21609998,
    -0.20039999, 0.38980004, 0.30979997,
    -0.02500000, 0.38980004, 0.35059997,
    0.21760000, 0.38980004, 0.33859998,
  ]),
  indices: new Uint16Array([
    1, 0, 20, 1, 20, 21, 2, 1, 21, 2, 21, 22,
    3, 2, 22, 3, 22, 23, 6, 4, 24, 6, 24, 26,
    8, 5, 25, 8, 25, 27, 9, 7, 27, 9, 27, 28,
    10, 9, 28, 10, 28, 29, 0, 11, 29, 0, 29, 20,
    13, 12, 30, 13, 30, 31, 14, 13, 31, 14, 31, 32,
    15, 14, 32, 15, 32, 33, 16, 15, 33, 16, 33, 34,
    17, 16, 34, 17, 34, 35, 18, 17, 35, 18, 35, 36,
    19, 18, 36, 19, 36, 37, 12, 19, 37, 12, 37, 30,
  ]),
  normals: new Float32Array([
    -0.02599901, 0.99966189, 0.00039998,
    -0.29589745, -0.21679815, 0.93029203,
    -0.05350148, -0.29230809, 0.95482646,
    0.27838794, -0.21689060, 0.93565946,
    0.27838794, -0.21689060, 0.93565946,
    0.99734344, -0.07280317, 0.00240010,
    0.99734344, -0.07280317, 0.00240010,
    0.34651813, -0.26461384, -0.89994705,
    0.34648695, -0.26459005, -0.89996605,
    0.08089871, -0.28339549, -0.95558484,
    -0.33848320, -0.22098904, -0.91465456,
    -0.33851415, -0.22100924, -0.91463823,
    -0.03660106, -0.99932898, -0.00140004,
    -0.31541152, -0.22360816, 0.92223368,
    -0.05380120, -0.29840667, 0.95292124,
    0.33598768, -0.17969343, 0.92456614,
    0.99648941, -0.07989914, 0.02499973,
    0.38481570, -0.17610719, -0.90603705,
    0.03689968, -0.34739701, -0.93699185,
    -0.28370657, -0.23280541, -0.93022160,
    -0.20610600, 0.97852852, -0.00150004,
    -0.10749614, 0.91596712, 0.38658611,
    -0.05279877, 0.88257950, 0.46718916,
    0.05459779, 0.89106403, 0.45058181,
    0.05459779, 0.89106403, 0.45058181,
    0.20110995, 0.97954841, -0.00630031,
    0.20109024, 0.97955246, -0.00629969,
    0.16789351, 0.90456510, -0.39188487,
    0.07150016, 0.87030189, -0.48730108,
    -0.09939625, 0.89556624, -0.43368364,
    -0.22299565, 0.97008108, 0.09599813,
    -0.10300169, 0.90831496, 0.40540669,
    -0.04340123, 0.88132490, 0.47051329,
    0.04679796, 0.88886129, 0.45578017,
    0.21789335, 0.97457035, -0.05229841,
    0.10670358, 0.91963079, -0.37801264,
    0.05089917, 0.85038609, -0.52369148,
    -0.07230174, 0.88282121, -0.46411115,
  ]),
  materialIndex: 1,
};

const MIST_MESH_2: RuneMesh = {
  name: "Mist_Rune_primitive2",
  positions: new Float32Array([
    0.47700000, 0.38979998, -0.20660003,
    0.26320001, 0.38979998, -0.28830004,
    0.02300000, 0.38979998, -0.33870003,
    -0.16910000, 0.38979998, -0.33870003,
    -0.39010000, 0.38979998, -0.24990003,
    -0.39010000, 0.38979998, -0.24990003,
    -0.19200000, 0.38980001, -0.16500004,
    0.01340000, 0.38980001, -0.07690003,
    0.24879999, 0.38980001, -0.11300003,
    0.43140000, 0.38980004, 0.24969997,
    0.21520001, 0.38980001, 0.16809997,
    -0.02740000, 0.38980001, 0.12479997,
    -0.21240000, 0.38980001, 0.12479997,
    -0.44049999, 0.38980004, 0.21609998,
    -0.20039999, 0.38980004, 0.30979997,
    -0.02500000, 0.38980004, 0.35059997,
    0.21760000, 0.38980004, 0.33859998,
    0.25029999, 0.37379998, -0.24450003,
    0.35350001, 0.37379998, -0.20510003,
    0.23660000, 0.37380001, -0.15710004,
    0.01940000, 0.37380001, -0.12390003,
    -0.17410000, 0.37379998, -0.20680003,
    -0.17410000, 0.37379998, -0.20680003,
    -0.27149999, 0.37379998, -0.24850003,
    -0.16030000, 0.37379998, -0.29330003,
    0.01830000, 0.37379998, -0.29330003,
    -0.02090000, 0.37380004, 0.30489996,
    -0.18690000, 0.37380004, 0.26619998,
    -0.31670001, 0.37380004, 0.21559997,
    -0.20360000, 0.37380001, 0.17029998,
    -0.03140000, 0.37380001, 0.17029998,
    0.20299999, 0.37380004, 0.21209997,
    0.30800000, 0.37380004, 0.25169998,
    0.20739999, 0.37380004, 0.29359996,
  ]),
  indices: new Uint16Array([
    11, 10, 31, 11, 31, 30, 25, 17, 18, 18, 19, 20,
    21, 23, 24, 18, 20, 21, 24, 25, 18, 18, 21, 24,
    33, 26, 27, 27, 28, 29, 29, 30, 31, 31, 32, 33,
    33, 27, 29, 29, 31, 33, 1, 0, 18, 1, 18, 17,
    0, 8, 19, 0, 19, 18, 8, 7, 20, 8, 20, 19,
    7, 6, 22, 7, 22, 20, 6, 4, 23, 6, 23, 22,
    5, 3, 24, 5, 24, 23, 3, 2, 25, 3, 25, 24,
    2, 1, 17, 2, 17, 25, 10, 9, 32, 10, 32, 31,
    9, 16, 33, 9, 33, 32, 16, 15, 26, 16, 26, 33,
    15, 14, 27, 15, 27, 26, 14, 13, 28, 14, 28, 27,
    13, 12, 29, 13, 29, 28, 12, 11, 30, 12, 30, 29,
  ]),
  normals: new Float32Array([
    -0.20610600, 0.97852852, -0.00150004,
    -0.10749614, 0.91596712, 0.38658611,
    -0.05279877, 0.88257950, 0.46718916,
    0.05459779, 0.89106403, 0.45058181,
    0.20110995, 0.97954841, -0.00630031,
    0.20109024, 0.97955246, -0.00629969,
    0.16789351, 0.90456510, -0.39188487,
    0.07150016, 0.87030189, -0.48730108,
    -0.09939625, 0.89556624, -0.43368364,
    -0.22299565, 0.97008108, 0.09599813,
    -0.10300169, 0.90831496, 0.40540669,
    -0.04340123, 0.88132490, 0.47051329,
    0.04679796, 0.88886129, 0.45578017,
    0.21789335, 0.97457035, -0.05229841,
    0.10670358, 0.91963079, -0.37801264,
    0.05089917, 0.85038609, -0.52369148,
    -0.07230174, 0.88282121, -0.46411115,
    -0.04960008, 0.98440150, 0.16880026,
    -0.11229702, 0.99367370, 0.00139996,
    -0.04799937, 0.98378707, -0.17279773,
    0.02399998, 0.98179912, -0.18839982,
    0.06630327, 0.98574863, -0.15460762,
    0.06629673, 0.98575146, -0.15459237,
    0.11610423, 0.99323618, 0.00130005,
    0.03509877, 0.98276555, 0.18149364,
    -0.01840038, 0.98402019, 0.17710363,
    0.01619965, 0.98347896, -0.18029614,
    0.05180139, 0.98452646, -0.16740450,
    0.11209964, 0.99369685, -0.00050000,
    0.03489965, 0.98279026, 0.18139821,
    -0.01559949, 0.98426760, 0.17599419,
    -0.04700006, 0.98420141, 0.17070023,
    -0.11239569, 0.99366190, 0.00179993,
    -0.04040076, 0.98301860, -0.17900340,
  ]),
  materialIndex: 2,
};

export const MIST_MESHES: RuneMesh[] = [
  MIST_MESH_0,
  MIST_MESH_1,
  MIST_MESH_2,
];
